"use client";

var __jsx = React.createElement;
import React, { useState } from 'react';
import MusclePlatformLayout from '@modules/layout';
import MuscleRegistrationScreen from '@modules/shared/screen-templates/registration-screen';
import { useCustomer } from '@lib/context/shared/customer-context';
import { useTranslations } from 'next-intl';
import customersManager from '@lib/data/managers/shared/customers-manager';
import { useModalMessages } from '@lib/context/shared/modal-message-context';
import imagesStoryblokService from '@lib/storyblok/services/financial-entity-services/images-service';
import ERROR_CODES from '@lib/error-codes';
const MuscleGuestRegistrationPage = _ref => {
  let {
    onClose
  } = _ref;
  const t = useTranslations('Shared.Auth');
  const {
    loginRegisteredUser
  } = useCustomer();
  const {
    showModalMessage
  } = useModalMessages();
  const {
    0: isRegisteringGuestCustomer,
    1: setIsRegisteringGuestCustomer
  } = useState(false);
  const registerGuestCustomer = async customerData => {
    const guestAccessToken = localStorage.getItem('guest-access-token');
    if (guestAccessToken) {
      setIsRegisteringGuestCustomer(true);
      const guestCustomerRegisterResult = customerData.provider_token ? await customersManager.registerThirdParty(customerData) : await customersManager.registerGuestUser(customerData);
      if (guestCustomerRegisterResult.error) {
        manageErrorRegisteringGuestCustomer(guestCustomerRegisterResult);
      } else {
        const customer = guestCustomerRegisterResult;
        const confirmationImage = await imagesStoryblokService.getAccountCreatedSuccessfullyImage();
        showModalMessage({
          title: t('ACCOUNT_CREATED'),
          message: t('ACCOUNT_CREATED_MESSAGE', {
            email: customer.email
          }),
          image: confirmationImage,
          closeable: false,
          actions: [{
            text: t('CONTINUE'),
            onClick: () => {
              if (customer.access_token) {
                loginRegisteredUser(customer, customer.access_token);
                localStorage.removeItem('guest-access-token');
                onClose();
              } else {
                manageErrorRegisteringGuestCustomer({});
              }
            }
          }]
        });
      }
      setIsRegisteringGuestCustomer(false);
    }
  };
  const manageErrorRegisteringGuestCustomer = data => {
    switch (data.code) {
      case ERROR_CODES.GuestCustomers.DATA_ALREADY_EXISTS:
        showModalMessage({
          title: t('ERROR_REGISTERING_USER'),
          message: t('USER_DATA_ALREADY_EXISTS_MESSAGE'),
          closeable: true,
          actions: [{
            text: t('CONTINUE'),
            onClick: () => {}
          }]
        });
        break;
      default:
        showModalMessage({
          title: t('ERROR_REGISTERING_USER'),
          message: t('ERROR_REGISTERING_USER_MESSAGE'),
          closeable: true,
          actions: [{
            text: t('RETURN_HOME'),
            onClick: onClose
          }]
        });
        break;
    }
  };
  return __jsx(MusclePlatformLayout, {
    headerProps: {
      hideContent: true,
      onClickLogo: () => {
        onClose();
      }
    },
    showCustomerSupport: true
  }, __jsx(MuscleRegistrationScreen, {
    title: t('CREATE_AN_ACCOUNT'),
    description: t('CREATE_AN_ACCOUNT_DESCRIPTION'),
    buttonText: t('REGISTER'),
    onSubmit: registerGuestCustomer,
    isSubmitting: isRegisteringGuestCustomer,
    onClickBack: () => {
      onClose();
    }
  }));
};
export default MuscleGuestRegistrationPage;